<div class="preview-details-container d-flex flex-column gap-4" *ngIf="specialOffer">
    <div class="d-flex flex-column align-items-start gap-2" >
        <div class="nav-container mb-3">        
            <button class="btn link-btn btn-back">
                <i class="app-icon icon icon-chevron-left icon-xl" (click)="redirectListHandler()"></i>
            </button>
            <span class="fw-semibold ms-3">{{'specialOffers.title' | translate}}</span>
        </div>
        <ng-container *ngIf="specialOffer?.status === SPECIAL_OFFER_STATUS.REQUESTED_OFFER">
            <div HJSuppress>{{'specialOffers.preview.information.requestedOn' | translate}}: {{specialOffer.requestedOn | localizedDate}}</div>
            <div HJSuppress>{{'specialOffers.preview.information.requestedBy' | translate}}: {{specialOffer.requestInitiatorName}}</div>
        </ng-container>
    </div>
    <preview-selector 
        *ngIf="specialOffer?.status === SPECIAL_OFFER_STATUS.REQUESTED_OFFER"
        class="mb-3 w-100"         
        [selectedTab]="selectedTab" 
        (tabChange)="tabChangeHandler($event)">
    </preview-selector>
 
    @switch (selectedTab) {
        @case (SPECIAL_OFFER_PREVIEW.INFO) {
        <preview-information [specialOffer]="specialOffer"></preview-information>
        }

        @case (SPECIAL_OFFER_PREVIEW.DOCUMENTS) {
        <preview-documents [specialOffer]="specialOffer"></preview-documents >
        }
    }
</div>